// extracted by mini-css-extract-plugin
export default {"newsPage":"styles_newsPage__BU+qd","newsPageContainer":"styles_newsPageContainer__3EUWh","newsPageSceleton":"styles_newsPageSceleton__VAMX+","loading":"styles_loading__tQWBa"};